import { Preset } from '../../types/types';
import { createControllerFactory } from '../BookingCalendar/controller';
import calendarWidgetSettingsParams from './settingsParams';

export default createControllerFactory(
  Preset.CALENDAR_WIDGET,
  calendarWidgetSettingsParams,
);
